<template>
  <input
    :value="text"
    class="tinput"
    type="tel"
    inputmode="tel"
    autocomplete="tel"
    @input="onInput"
    @blur="onBlur"
  />
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { formatPhone, toE164 } from '../../../utils/phone'

const model = defineModel<string>({ required: true })

// Format via the parsed number: a readable value needn't be E.164 yet.
const shown = (v: string) => {
  const e164 = toE164(v)
  return e164 ? formatPhone(e164) : v
}
const text = ref(shown(model.value))
let editing = false

watch(model, (v) => {
  if (!editing) text.value = shown(v)
})

function onInput(e: Event): void {
  editing = true
  text.value = (e.target as HTMLInputElement).value
  model.value = toE164(text.value) ?? text.value
}

function onBlur(): void {
  editing = false
  text.value = shown(model.value)
}
</script>
